<template>
  <div>
    <LabelHeader msg="日志列表搜索"></LabelHeader>
    <div style="padding-left: 50px">
      <el-form :inline="true" :model="searchParams" class="searchForm">
        <el-form-item label="用户名：">
          <el-input type="text" size="small" v-model="searchParams.name" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="工号：">
          <el-input type="text" size="small" v-model="searchParams.account" placeholder="请输入工号" />
        </el-form-item>
        <el-form-item label="业务资源：">
          <el-input type="text" size="small" v-model="searchParams.bizModel" placeholder="请输入业务资源" />
        </el-form-item>
        <el-form-item label="事件：">
          <el-input type="text" size="small" v-model="searchParams.event" placeholder="请输入事件" />
        </el-form-item>
        <el-form-item label="结果：">
          <el-select v-model="searchParams.result" placeholder="请选择" size="small" style="width: 200px" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <LabelHeader msg="查询结果"></LabelHeader>

    <div class="table-box">
      <el-table
        :data="datas"
        max-height="580"
        v-loading="refreshing"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        stripe
        border
        style="width: 100%"
      >
        <el-table-column prop="name" label="姓名" align="center" width="100px"></el-table-column>
        <el-table-column prop="account" label="工号" align="center" width="100px"></el-table-column>
        <el-table-column prop="teamName" label="所属单位" align="center" width="150px"></el-table-column>
        <el-table-column prop="bizModel" label="业务资源" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="event" label="事件" align="center" min-width="80px" >
          <template slot-scope="scope">
            <el-popover placement="top-start" :content="scope.row.event" trigger="hover">
               <!-- <span>{{ scope.row.event }}</span> -->
               <div slot="reference">{{ scope.row.events }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="result" label="结果" align="center" width="80px">
          <template slot-scope="data">
            <span type="text" v-if="data.row.result === 'true'" style="color: #67c23a">成功</span>
            <span type="text" v-else style="color: #f56c6c">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="createAt" label="时间" align="center" width="150"></el-table-column>
        <el-table-column prop="ip" label="IP地址" align="center" width="120px"></el-table-column>
        <el-table-column prop="os" label="操作系统" align="center" max-width="120px"> </el-table-column>
        <el-table-column prop="browser" label="浏览器" align="center" min-width="180px"> </el-table-column>
        <el-table-column label="操作" align="center" width="100px">
          <template slot-scope="data">
            <el-button type="success" @click="openDialog(data.row.id)" icon="el-icon-document" size="mini">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationBox">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @size-change="sizeChange"
          @current-change="currentChange"
          :page-size="10"
        ></el-pagination>
        <el-button class="refreshBtn" circle @click="list" :icon="refreshing ? 'el-icon-refresh refAnimation' : 'el-icon-refresh'"> </el-button>
      </div>
      <el-dialog :dialogTitle="dialogTitle" :visible.sync="showDetail" @dialogClose="close" :popupWidth="'900px'">
        <Detail :params="{ id: byId }" @close="close" @success="success"></Detail>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import LabelHeader from "../../components/LabelHeader";
import Detail from './detail';
export default {
  data() {
    return {
      datas: [],
      name: null,
      ip: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      options: [
        { value: 'true', label: '成功' },
        { value: 'false', label: '失败' }
      ],
      homeData: [{ title: '日志列表' }],
      byId: null,
      refreshing: false,
      dialogFull: false,
      showDetail: false,
      dialogTitle: '',
      searchParams: {
        name: '',
        account: '',
        bizModel: '',
        event: '',
        result: '',
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  components: {
    Detail,
    LabelHeader
  },
  mounted() {
    this.list();
  },
  methods: {
    sizeChange(size) {
      this.pagination.size = size;
      this.list();
    },
    currentChange(pageNo) {
      this.pagination.page = pageNo;
      this.list();
    },
    list() {
      this.searchParams.pageNo = this.pagination.page;
      this.searchParams.pageSize = this.pagination.size;
      this.refreshing = true;
      httpKit.post($api_eap.log.search, this.searchParams).then(res => {
        this.refreshing = false;
        if (res.data.code === '200') {
          this.datas = res.data.data;
          this.datas.forEach(item => {
            if (item.event.length<10) {
              item.events = item.event;
            } else {
              item.events = item.event.substring(0,9) + '...';
            }
          });
          this.pagination.total = +res.data.totalItems;
        } else {
          if (res.data.code === '500') {
            this.datas = [];
          }
        }
      });
    },
    openDialog(id) {
      this.byId = id;
      this.dialogTitle = '日志详情';
      this.showDetail = true;
    },
    close() {
      this.$emit('close');
      this.showDetail = false;
    },
    success() {
      this.list();
      this.showDetail = false;
    },
    reRun() {
      this.pagination = {
        page: 1,
        size: 10,
        total: 0
      };
      this.list();
    }
  }
};
</script>
<style lang="less" scoped>
.el-tooltip_popper {
  max-width: 80%;
  background: #fff;
}
.el-tooltip__popper.is-dark {
  background: #fff;
}
</style>
